module.exports = require('./FileUploadTableView');
